module.exports = require('./FileUploadTableView');
